interface TwoSegmentFieldProps {
  label: string
  value?: string
  className?: string
}
export const TwoSegmentField = ({
  value,
  label,
  className,
}: TwoSegmentFieldProps) => {
  return (
    <div
      className={`flex flex-row gap-1 bg-primary-white rounded-2xl items-center justify-center pl-4 p-2 ${className}`}
    >
      <div className="flex flex-row justify-between flex-1">
        <p className="text-xl font-thin">{label}</p>
      </div>
      <div className="flex flex-row flex-1 rounded-xl bg-primary-black h-full justify-center items-center p-2">
        <p className="text-primary-white text-xl">{value}</p>
      </div>
    </div>
  )
}
